module.exports = __webpack_public_path__ + "static/img/aq.6f1f242c.svg";